export const homeObjOne = {
    lightBg: false,
    imgStart: '',
    lightTopLine: true,
    lightTextDesc:  true,
    buttonLabel: 'Get Started', 
    description: 'We help business owners increase their revenue. Our team of unique specialist can help you achieve your business goals.',
    headline: 'Lead generation specialists for Online Businesses',
    lightText: true,
    topLine: 'Marketing Agency',
    primary: true,
    img: require('../../images/svg-1.svg'),
    alt: 'Image',
    start: '',
};

export const homeObjTwo = {
   lightBg: true,
   imgStart: 'start',
   lightTopLine: false,
   lightTextDesc: false,
   buttonLabel: 'Get Started', 
   description: 'We help business owners increase their revenue. Our team of unique specialist can help you achieve your business goals.',
   headline: 'Lead generation specialists for Online Businesses',
   lightText: false,
   topLine: 'Marketing Agency',
   primary: false,
   img: require('../../images/profile.jpg'),
   alt: 'Image',
   start: 'true',
};

export const homeObjThree = {
   lightBg: false,
   imgStart: '',
   lightTopLine: true,
   lightTextDesc:  true,
   buttonLabel: 'Get Started', 
   description: 'We help business owners increase their revenue. Our team of unique specialist can help you achieve your business goals.',
   headline: 'Lead generation specialists for Online Businesses',
   lightText: true,
   topLine: 'Marketing Agency',
   primary: true,
   img: require('../../images/svg-2.svg'),
   alt: 'Image',
   start: '',
};

export const homeObjFour = {
   lightBg: false,
   imgStart: 'start',
   lightTopLine: true,
   lightTextDesc:  true,
   buttonLabel: 'Get Started', 
   description: 'We help business owners increase their revenue. Our team of unique specialist can help you achieve your business goals.',
   headline: 'Lead generation specialists for Online Businesses',
   lightText: true,
   topLine: 'Marketing Agency',
   primary: true,
   img: require('../../images/svg-3.svg'),
   alt: 'Image',
   start: 'true',
};